<template>
  <div
    v-if="canEditDescription"
    class="sf-layer-white sf-layer-rounded sf-pad-2 sf-below-2"
  >
    <div class="sf-font-m sf-fwdb sf-c-text-darker sf-below-1">
      {{ I18n.t('js.report_graph.edit.description_new') }}
    </div>
    <div class="sf-dim-el sf-below-1">
      {{ I18n.t('js.report_graph.edit.description_notice') }}
    </div>
    <div>
      <textarea
        v-if="readOnly"
        class="sf-full-width"
        style="height: 200px"
        disabled="true"
        :value="graph.description"
      />
      <SfAceEditor
        v-else
        v-model="description"
        :available-actions="availableActions"
      />
    </div>
  </div>
</template>

<script>
import SfAceEditor from '@app/shared/vue/components/form/sf-ace-editor'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'SfDescription',
  components: {
    SfAceEditor,
  },
  data() {
    return {
      availableActions: [
        'makeBold',
        'makeItalic',
        'makeUnderlined',
        'showDiff',
        'verify',
      ],
    }
  },
  computed: {
    ...mapState(['canEditDescription', 'readOnly', 'graph']),
    description: {
      get() {
        return this.graph.description || ''
      },
      set(value) {
        this.setDescription({ description: value })
      },
    },
  },
  methods: {
    ...mapActions(['setDescription']),
  },
}
</script>
